import * as z from 'zod'

import {safeOptional} from '../../safe-optional'
import {buildEntrySchemaFor} from '../entry'
import {AssetSchema} from './asset'

// This schema is a shared source of truth for github-ui (front-end rendering) and
// the github/marketing-hub Next.js app (server-side page config). Some fields below have
// no github-ui consumers today but are read by github/marketing-hub's back-end, so do not
// remove "unused" fields without checking github/marketing-hub first.
export const PageSeoSchema = buildEntrySchemaFor('pageSeo', {
  fields: z.lazy(() =>
    z.object({
      description: z.string().optional(),
      socialMediaImage: safeOptional(AssetSchema),
      noIndex: z.boolean().default(false),
    }),
  ),
})

export type PageSeo = z.infer<typeof PageSeoSchema>
